<template>
  <div>
    <!-- 顶部 -->
    <div class="header">
      <div class="left">
        <!-- <Breadcrumb></Breadcrumb> -->
        <tagsview @refreshDeleteQuery="refreshDeleteQuery" @refreshAddQuery="refreshAddQuery"></tagsview>
      </div>
      <div class="right">
        <div>
          <b>{{username}}</b>
        </div>
        <el-dropdown>
          <div class="avatar-wrapper">
            <img class="user-avatar" src="../../../assets/image/logo4.jpg" />
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <el-dropdown-item>
              <p @click="passwdDialogVisible = true">更改密码</p>
            </el-dropdown-item>
            <el-dropdown-item>
              <p @click="logOut">退出</p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码弹框 -->
    <el-dialog center title="修改密码" :visible.sync="passwdDialogVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="账号" prop="username">
          <el-input type="text" v-model="form.username" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input autocomplete="new-password" type="password" v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="form.confirmPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="passwdDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 内容 -->
    <div class="substance">
      <router-view :queryCache="queryCache" @updateQueryCache="updateQueryCache"></router-view>
    </div>
    <!-- 底部域名 -->
    <!-- <div class="footer">
      <p>cwehbjfv@域名</p>
    </div>-->
  </div>
</template>
<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
// 修改密码
import { updatePassword } from "@/api/setup.js";
import { mapGetters, mapActions } from "vuex";
import { getCookie } from "@/unit/cookie";
// 引入tagsview组件
import tagsview from "@/components/tags/TagsView.vue";
export default {
  components: {
    Breadcrumb,
    tagsview
  },
  data() {
    return {
      username: "",
      // 修改密码弹框
      passwdDialogVisible: false,
      form: {
        username: getCookie("username"),
        newPassword: "",
        confirmPassword: ""
      },
      // 规则
      rules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: this.validatePassword, trigger: "blur" }
        ]
      },
      queryCache: {}
    };
  },
  created() {
    // console.log("进入-----");
    this.username = getCookie("username");
    this.getChannelAll();
  },
  methods: {
    updateQueryCache(tabName, query) {
      this.queryCache[tabName] = query;
      console.log("query", tabName, query, this.queryCache);
    },
    // tab组件传过来的删除
    refreshDeleteQuery(item) {
      delete this.queryCache[item.name];
      console.log("deleteQuery", item, this.queryCache);
    },
    // tab组件传过来的增加
    refreshAddQuery(item) {
      if (this.queryCache || this.queryCache in item.name) {
        return;
      } else {
        this.queryCache[item.name] = {};
      }
      console.log("addQuery", item, this.queryCache);
    },
    //引入方法，通过vuex来获取所有渠道
    ...mapActions("channell", ["changeChannel"]),
    getChannelAll() {
      let arr = JSON.parse(localStorage.getItem("channelArr"));
      if (!arr || arr.length == 0) {
        this.changeChannel(true);
      }
    },
    // 退出按钮
    logOut() {
      // 清空token
      window.sessionStorage.clear();
      localStorage.removeItem("channelArr");
      localStorage.removeItem("labelArr");
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
      this.$router.push("/login");
    },
    // 更改密码
    validatePassword(rule, value, callback) {
      if (value !== this.form.newPassword) {
        callback(new Error("确认密码与新密码不一致"));
      } else {
        callback();
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let obj = {
            username: this.form.username,
            password: this.form.newPassword
          };
          // 这里应该是发送请求到后端来更新密码
          updatePassword(obj).then(res => {
            if (res.data) {
              this.passwdDialogVisible = false;
              this.$message.success("修改密码成功,请重新登录!");
              setTimeout(() => {
                this.logOut();
              }, 1000);
            }
            // console.log("res", res);
          });
          // console.log("密码修改数据:", this.form);
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  // position: fixed;
  // top: 0;
  // z-index: 999;
  height: 50px;
  background: #ffffff;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left {
    // display: flex;
    width: 100%;
    overflow-x: auto;
    /deep/::-webkit-scrollbar {
      display: none; /* 针对Webkit浏览器隐藏滚动条 */
    }
    /deep/ ::-moz-scrollbar {
      display: none; /* 针对Firefox浏览器隐藏滚动条 */
    }
    /deep/ ::-ms-scrollbar {
      display: none; /* 针对IE浏览器隐藏滚动条 */
    }
  }
  .right {
    margin-right: 20px;
    display: flex;
    align-items: center;
    // position: fixed;
    // right: 0px;
    b {
      color: black;
      margin-right: 10px;
    }
    .avatar-wrapper {
      cursor: pointer;
      display: flex;
      align-items: center;
      .user-avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    .user-dropdown {
      span {
        font-size: 12px;
      }
    }
  }
}
.footer {
  height: 40px;
  font-size: 12px;
  color: #b5b3b3;
  text-align: center;
  p {
    line-height: 40px;
  }
}

.substance {
  margin: 20px 20px 0 20px;
  // margin: 60px 20px 0 20px;
  // height: calc(100vh - 110px);
}
</style>